module.exports = __webpack_public_path__ + "img/flavor9.79edd62c.png";